<template>
  <div>
    <v-simple-table>
      <template v-slot:default>
        <thead>
          <tr>
            <th>
              Исполнитель
            </th>
            <th>
              Тип задачи
            </th>
            <th>
              Статус
            </th>
            <th>
              Дата отправки задачи
            </th>
            <th>
              Дата ответа по задаче
            </th>
          </tr>
        </thead>
        <tbody>
          <template v-if="tasks && tasks.length > 0">
            <tr v-for="(item, idx) in tasks" :key="idx">
              <td>{{ item.employee_fullname }}</td>
              <td>
                <v-btn v-if="item.data" icon x-small plain title="Доп. сведения" @click="showDataFor = idx; showData = true">
                  <v-icon>mdi-information-outline</v-icon>
                </v-btn>

                {{ item.title }}
              </td>
              <td>
                <StatusChip :value="item.status" />
              </td>
              <td>
                <span v-if="item.first_record_created_at">{{ item.first_record_created_at.toLocaleDateString() }}</span>
                <span v-else>&mdash;</span>
                <br />
                <span v-if="item.first_record_created_at" class="font font--label-light font--color_light">{{ item.first_record_created_at.toLocaleTimeString() }}</span>
                <span v-else>&mdash;</span>
              </td>
              <td>
                <span v-if="item.first_decision_at">{{ item.first_decision_at.toLocaleDateString() }}</span>
                <span v-else>&mdash;</span>
                <br />
                <span v-if="item.first_decision_at" class="font font--label-light font--color_light">{{ item.first_decision_at.toLocaleTimeString() }}</span>
                <span v-else>&mdash;</span>
              </td>
            </tr>
          </template>
          <template v-else>
            <td colspan="5" class="text-center py-3">
              <span class="text--disabled text-body-2">{{ $vuetify.lang.t('$vuetify.noDataText') }}</span>
            </td>
          </template>
        </tbody>
      </template>
    </v-simple-table>

    <v-dialog v-model="showData" width="400px">
      <v-card>
        <v-card-title>Доп. сведения по задаче</v-card-title>
        <v-card-text v-if="showDataFor !== null">
          <pre class="text-pre-wrap overflow-auto">{{ JSON.stringify(tasks[showDataFor].data, null, 2) }}</pre>
        </v-card-text>
        <v-card-actions>
          <v-btn text @click="showData = false">Закрыть</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import StatusChip from "@/components/common/StatusChip";

export default {
  name: "AppDocumentProcess",

  components: {
    StatusChip,
  },

  props: {
    show: {
      type: Boolean,
      default: false
    },
  },

  data: () => ({
    showData: false, // FIXME: неявные наименования
    showDataFor: null,
  }),

  computed: {
    tasks() {
      if (!this.show) return [];

      const list = this.$store.state.app.tasks;
      return list?.map(item => ({
        title: item.title,
        employee_fullname: item.employee_fullname,
        status: item.status,
        first_record_created_at: item.request_utc_at ? new Date(item.request_utc_at) : null,
        first_decision_at: item.response_utc_at ? new Date(item.response_utc_at) : null,
        data: (item.data && item.data instanceof Object && !Array.isArray(item.data)) ? item.data : null
      }));
    }
  },

  watch: {
    show: {
      handler: async function(v) {
        if (v) {
          this.showData = false;

          await this.$store.dispatch('app/fetchTasksWithHistory');
        }
      },
      immediate: true
    },
    showData(v) {
      if (!v) {
        this.showDataFor = null;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
th {
  text-align: left;
}
</style>
